import pluralize from "pluralize";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { services } from "../../policies/actions";
import { ServiceDetailsShape } from "../../policies/proptypes";
import policySelectors from "../../policies/selectors";
import ActionButton from "../../shared/components/ActionButton";

const RemoveService = ({
  cancel,
  policyCount,
  remove,
  resourceCount,
  saving,
  service
}) => (
  <div className="l-services__popup p-card--highlighted">
    <p>
      Are you sure you want to remove&nbsp;
      <strong>
        {service.name}
        &nbsp;
      </strong>
      from RBAC? This action will also delete&nbsp;
      <strong>
        {`${resourceCount} ${pluralize("resource", resourceCount)} `}
        {`and ${policyCount} ${pluralize("policy", policyCount)} `}
      </strong>
      currently associated with this service.
    </p>
    <div>
      <button
        className="u-no-margin--bottom"
        type="button"
        disabled={saving}
        onClick={() => cancel()}
      >
        Cancel
      </button>
      <ActionButton
        type="negative"
        inProgress={saving}
        disabled={saving}
        onClick={() => remove(service)}
      >
        {saving ? "Removing..." : "Remove"}
      </ActionButton>
    </div>
  </div>
);

RemoveService.propTypes = {
  cancel: PropTypes.func.isRequired,
  policyCount: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
  resourceCount: PropTypes.number.isRequired,
  saving: PropTypes.bool,
  service: ServiceDetailsShape.isRequired
};

RemoveService.defaultProps = {
  saving: undefined
};

const mapStateToProps = state => ({
  policyCount: policySelectors.policies.getCountByCurrentService(state),
  resourceCount: policySelectors.resources.getCountByCurrentService(state),
  saving: state.services.saving
});

const mapDispatchToProps = {
  remove: services.remove
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveService);
